import script from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"

import "./ExportJSON.vue?vue&type=style&index=0&id=1bc24666&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc24666"]])

export default __exports__